export const TEN_THOUSAND = 10_000;

export const intlFormatNumberWithCompact = (number, locale, compactAtThreshold) => {
    const shouldCompact = number > compactAtThreshold
    const formatter = new Intl.NumberFormat(locale, shouldCompact ? {
        notation: 'compact',
    } : {})

    return formatter.format(number)
}


export const formatNumber = (number) => {
  const locale = localStorage.getItem('ulty-lng');
  return Number(number).toLocaleString(locale)
}